module.exports = __webpack_public_path__ + "static/palco-mobile-285413123fccf6d391fe23a7ff95f2e6.png";